import React, { useEffect } from "react";
import style from "../styles/Cart.module.css";
import { CartContext } from "../Contexts/CartContextProvider";
import { useContext } from "react";
import { Navigate, useNavigate } from "react-router-dom";
function Cart() {
  const naviget = useNavigate();
  const { cartItems, setcartItems } = useContext(CartContext);
  let TotalProducts = cartItems.length;
  let totalPrice = 0;
  cartItems.map((ele) => {
    totalPrice += Number(ele.price) * ele.qty;
  });
  // const []

  const removeFromCart = (id) => {
    const filteredData = cartItems.filter((ele) => ele.id !== id);
    setcartItems(filteredData);
  };

  // useEffect(() => {}, [cartItems]);

  // const [{ name, price, mrp, discount, id, img }] = data;

  return (
    <>
      <div className={style.cart_empty}></div>
      <div className={style.cart_cont}>
        <div className={style.cartitems}>
          <div className={style.total_cart_items}>
            <p>My Cart({TotalProducts})</p>
            <p>Shipping to: 413534</p>
          </div>
          {/* map throu the data and show the cart cards here  */}

          {cartItems?.map((ele, i) => {
            return (
              <div key={i + 1}>
                <div className={style.cart_Card}>
                  <div className={style.cart_Card_image}>
                    <div>
                      <img width="90%" src={ele.img} alt="cartimage" />
                    </div>
                    <div>
                      <button
                        disabled={ele.qty === 1}
                        className={style.qty_BTNS}
                        onClick={() => ele.qty - 1}
                      >
                        -
                      </button>
                      <button className={style.qty_BTNS}>{ele.qty}</button>
                      <button
                        onClick={() => ele.qty + 1}
                        className={style.qty_BTNS}
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <div>
                    <p style={{ color: "blue" }}>{ele.name}</p>
                    <p>1680511433382</p>
                    <p style={{ color: "red" }}>
                      RECOMMENDED SERVICES/WARRANTY
                    </p>
                    <div className={style.remove_wishlist_BTNS}>
                      <button onClick={() => removeFromCart(ele.id)}>
                        Remove
                      </button>
                      <button>Move to Wishlist</button>
                    </div>
                  </div>
                  <div>
                    <h2>{`₹${ele.price}`}</h2>
                    <p style={{ color: "green" }}>Free Shipping</p>
                    <p style={{ color: "blue" }}>Standard Delivery: Monday,</p>
                    <p style={{ color: "blue" }}>April 3 - April 4, 2023</p>
                    <p style={{ color: "gray" }}>
                      *Delivery assurance is subject to our
                    </p>
                    <p style={{ color: "gray" }}>
                      delivery locations staying open a
                    </p>
                    <p style={{ color: "gray" }}>per govt. regulations</p>
                  </div>
                </div>
              </div>
            );
          })}
        </div>

        <div className={style.Checkout_deatils}>
          <div className={style.checkout_BTN}>
            <button onClick={() => naviget("/checkout")}>CHECKOUT</button>
            <div className={style.checkout_BTN_details}>
              <p>To avail discount use coupon code : </p>
              <p>MASAI-B24</p>
              <div>
                <div className={style.coupan_cont}>
                  <input type="text" placeholder="Coupan Code" />
                  <button>Apply</button>
                </div>
                <hr />
                <h4>PRICE DETAILS</h4>
                <div className={style.pList_side}>
                  <p>{`Price (${TotalProducts} Items)`}</p>
                  <p>{totalPrice}</p>
                </div>
                <div className={style.pList_side}>
                  <p>Delivery Charges</p>
                  <p> FREE</p>
                </div>
                <div className={style.pList_side}>
                  <p>Discount</p>
                  <p>{cartItems.length === 0 ? "00%" : "15%"}</p>
                </div>
                <div className={style.pList_side}>
                  <h4>AMOUNT PAYABLE</h4>
                  <h4>{totalPrice}</h4>
                </div>
              </div>
            </div>
            <p>
              Safe and Secure Payments. Easy returns. 100% Authentic products.
            </p>
          </div>
        </div>
      </div>
    </>
  );
}

export default Cart;
